var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import { DEFAULT_POINT_CARD_ICON, DEFAULT_TRUMP_CARD_ICON, } from "./state/Settings";
import { CompactPicker } from "react-color";
import { SettingsSection, SettingRow, SettingButton, SettingToggleRow, } from "./SettingsWidgets";
var Picker = React.lazy(function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, import("emoji-picker-react")];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); });
var SettingsPane = function (props) {
    var settings = props.settings;
    var toggle = function (partialSettings) { return function () {
        props.onChangeSettings(__assign(__assign({}, props.settings), partialSettings));
    }; };
    var _a = React.useState(""), link = _a[0], setLink = _a[1];
    var setChatLink = function (event) {
        event.preventDefault();
        if (link.length > 0) {
            window.send({ Action: { SetChatLink: link } });
        }
        else {
            window.send({ Action: { SetChatLink: null } });
        }
        setLink("");
    };
    return (React.createElement("div", { className: "settings" },
        React.createElement(SettingsSection, { title: "Appearance", subtitle: "How cards are drawn." },
            React.createElement(SettingToggleRow, { name: "four-color-mode", label: "Four-color suits", hint: "Distinct colors for \u2666 and \u2663.", checked: settings.fourColor, onChange: toggle({ fourColor: !settings.fourColor }) }),
            React.createElement(SettingToggleRow, { name: "svg-cards", label: "Use SVG cards", checked: settings.svgCards, onChange: toggle({ svgCards: !settings.svgCards }) }),
            React.createElement(SettingToggleRow, { name: "show-card-labels", label: "Always show card labels", checked: settings.showCardLabels, onChange: toggle({ showCardLabels: !settings.showCardLabels }) }),
            React.createElement(SettingRow, { label: "Icon on point cards", hint: "Shown on 5 / 10 / K." },
                React.createElement(EmojiPicker, { value: settings.pointCardIcon, setEmoji: function (emoji) { return toggle({ pointCardIcon: emoji })(); }, setDefault: toggle({ pointCardIcon: DEFAULT_POINT_CARD_ICON }) })),
            React.createElement(SettingRow, { label: "Icon on trump cards" },
                React.createElement(EmojiPicker, { value: settings.trumpCardIcon, setEmoji: function (emoji) { return toggle({ trumpCardIcon: emoji })(); }, setDefault: toggle({ trumpCardIcon: DEFAULT_TRUMP_CARD_ICON }) })),
            React.createElement(SettingRow, { label: "Suit color overrides", hint: "Customize individual suit colors (text cards only)." }, settings.svgCards ? (React.createElement("span", { className: "text-sm text-[var(--text-secondary)]" }, "Disabled with SVG cards")) : (React.createElement(SuitOverrides, { suitColors: settings.suitColorOverrides, setSuitColors: function (newOverrides) {
                    return props.onChangeSettings(__assign(__assign({}, props.settings), { suitColorOverrides: newOverrides }));
                } }))),
            React.createElement(SettingToggleRow, { name: "disable-suit-highlights", label: "Disable suit highlights", checked: settings.disableSuitHighlights, onChange: toggle({
                    disableSuitHighlights: !settings.disableSuitHighlights,
                }) })),
        React.createElement(SettingsSection, { title: "Hand & layout", subtitle: "How your hand and the game board are arranged." },
            React.createElement(SettingToggleRow, { name: "reverse-card-order", label: "Reverse card order in hand", checked: settings.reverseCardOrder, onChange: toggle({ reverseCardOrder: !settings.reverseCardOrder }) }),
            React.createElement(SettingToggleRow, { name: "separate-cards-by-suit", label: "Separate cards by effective suit", checked: settings.separateCardsBySuit, onChange: toggle({
                    separateCardsBySuit: !settings.separateCardsBySuit,
                }) }),
            React.createElement(SettingToggleRow, { name: "show-trick-in-player-order", label: "Show tricks in player order", checked: settings.showTrickInPlayerOrder, onChange: toggle({
                    showTrickInPlayerOrder: !settings.showTrickInPlayerOrder,
                }) }),
            React.createElement(SettingToggleRow, { name: "show-points-above-game", label: "Show points bar above the game", hint: "Otherwise the points bar appears below.", checked: settings.showPointsAboveGame, onChange: toggle({
                    showPointsAboveGame: !settings.showPointsAboveGame,
                }) }),
            React.createElement(SettingToggleRow, { name: "hide-chat-box", label: "Hide chat box", checked: settings.hideChatBox, onChange: toggle({ hideChatBox: !settings.hideChatBox }) })),
        React.createElement(SettingsSection, { title: "Gameplay", subtitle: "Last trick, autoplay and draw behavior." },
            React.createElement(SettingToggleRow, { name: "show-last-trick", label: "Show last trick", checked: settings.showLastTrick, onChange: toggle({ showLastTrick: !settings.showLastTrick }) }),
            React.createElement(SettingToggleRow, { name: "unset-auto-play-when-winner-changes", label: "Unset auto-play if the winner changes", checked: settings.unsetAutoPlayWhenWinnerChanges, onChange: toggle({
                    unsetAutoPlayWhenWinnerChanges: !settings.unsetAutoPlayWhenWinnerChanges,
                }) }),
            React.createElement(SettingToggleRow, { name: "beep-on-turn", label: "Beep on your turn", checked: settings.beepOnTurn, onChange: toggle({ beepOnTurn: !settings.beepOnTurn }) }),
            React.createElement(SettingToggleRow, { name: "play-sound-when-drawing-card", label: "Play a sound when drawing a card", checked: settings.playDrawCardSound, onChange: toggle({
                    playDrawCardSound: !settings.playDrawCardSound,
                }) }),
            React.createElement(SettingRow, { label: "Autodraw speed" },
                React.createElement("select", { className: "sj-input !min-h-[40px] w-full !py-1 sm:w-auto sm:min-w-[10rem]", value: settings.autodrawSpeedMs !== null ? settings.autodrawSpeedMs : "", onChange: function (e) {
                        return toggle({ autodrawSpeedMs: parseInt(e.target.value) })();
                    } },
                    React.createElement("option", { value: "250" }, "Default"),
                    React.createElement("option", { value: "500" }, "Slow"),
                    React.createElement("option", { value: "10" }, "Fast")))),
        React.createElement(SettingsSection, { title: "Advanced", subtitle: "Voice-chat link, title bar and debugging." },
            React.createElement(SettingToggleRow, { name: "show-player-name", label: "Show player name in title bar", checked: settings.showPlayerName, onChange: toggle({ showPlayerName: !settings.showPlayerName }) }),
            React.createElement(SettingToggleRow, { name: "show-debug-info", label: "Show debugging information", checked: settings.showDebugInfo, onChange: toggle({ showDebugInfo: !settings.showDebugInfo }) }),
            React.createElement(SettingRow, { label: "Voice chat link", hint: "Share a link to a voice call with the room." },
                React.createElement("input", { type: "text", className: "sj-input !min-h-[40px] w-full !py-1 sm:w-[14rem]", value: link, onChange: function (evt) {
                        evt.preventDefault();
                        setLink(evt.target.value);
                    }, placeholder: "https://\u2026 link to voice chat" }),
                React.createElement(SettingButton, { onClick: setChatLink }, "Set")))));
};
var SuitOverrides = function (props) {
    var suits = ["♢", "♡", "♤", "♧", "🃟", "🃏"];
    var labels = ["♦", "♥", "♠", "♣", "LJ", "HJ"];
    return (React.createElement("div", { className: "flex flex-wrap items-center gap-2" },
        suits.map(function (suit, idx) { return (React.createElement(SuitColorPicker, { key: suit, suit: suit, label: labels[idx], suitColor: props.suitColors[suit], setSuitColor: function (color) {
                var n = __assign({}, props.suitColors);
                n[suit] = color;
                props.setSuitColors(n);
            } })); }),
        React.createElement(SettingButton, { onClick: function (evt) {
                evt.preventDefault();
                props.setSuitColors({});
            } }, "Reset")));
};
var SuitColorPicker = function (props) {
    var _a = React.useState(false), showPicker = _a[0], setShowPicker = _a[1];
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: props.suit, style: {
                color: props.suitColor,
                cursor: "pointer",
                fontWeight: 700,
                fontSize: "1.1rem",
                minWidth: "1.4rem",
                textAlign: "center",
            }, onClick: function () { return setShowPicker(true); } }, props.label),
        showPicker ? (React.createElement("div", { style: { position: "absolute", zIndex: 10 } },
            React.createElement("div", { style: { position: "fixed", top: 0, left: 0, right: 0, bottom: 0 }, onClick: function () { return setShowPicker(false); } }),
            React.createElement(CompactPicker, { color: props.suitColor, onChangeComplete: function (c) { return props.setSuitColor(c.hex); } }))) : null));
};
var EmojiPicker = function (props) {
    var _a = React.useState(false), showPicker = _a[0], setShowPicker = _a[1];
    return (React.createElement("div", { className: "flex flex-wrap items-center gap-2" },
        props.value !== "" && (React.createElement("span", { className: "text-lg leading-none" }, props.value)),
        React.createElement(SettingButton, { onClick: function () { return setShowPicker(!showPicker); } }, showPicker ? "Hide" : "Pick"),
        React.createElement(SettingButton, { onClick: props.setDefault }, "Default"),
        props.value !== "" && (React.createElement(SettingButton, { onClick: function () { return props.setEmoji(""); } }, "No icon")),
        showPicker && (React.createElement("div", { className: "w-full" },
            React.createElement(React.Suspense, { fallback: "…" },
                React.createElement(Picker, { onEmojiClick: function (emoji) {
                        props.setEmoji(emoji.emoji);
                    } }))))));
};
export default SettingsPane;
